module.exports = __webpack_public_path__ + "static/media/c3.8f4a3c34.jpg";